import { render, staticRenderFns } from "./SnackbarsContainer.vue?vue&type=template&id=42130524&"
import script from "./SnackbarsContainer.vue?vue&type=script&lang=ts&"
export * from "./SnackbarsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SnackbarsContainer.vue?vue&type=style&index=0&id=42130524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports